import Vue from 'vue';
import {
    ADD_MEDICAL_LEAVE,
    ADD_SICK_LEAVE,
    ADD_VACATION,
    ADD_TIME_OFF,
    SAVE_MEDICAL_LEAVES,
    SAVE_VACATIONS,
    SAVE_SICK_LEAVES,
    SAVE_TIME_OFF,
    FETCH_VACATIONS,
    FETCH_HOLIDAYS,
    ADD_HOLIDAY,
    DELETE_HOLIDAY,
    SAVE_HOLIDAY,
    EDIT_HOLIDAY,
    CANCEL_EDIT_HOLIDAY,
    REMOVE_MEDICAL_LEAVE,
    REMOVE_VACATION,
    REMOVE_SICK_LEAVE,
    REMOVE_TIME_OFF,
    EDIT_SICK_LEAVE,
    EDIT_VACATION,
    EDIT_TIME_OFF,
    EDIT_MEDICAL_LEAVE,
    DELETE_MEDICAL_LEAVES,
    DELETE_VACATIONS,
    DELETE_SICK_LEAVES,
    DELETE_TIME_OFF,
    CLEAR_ALL_VACATIONS
} from './mutation-types';

export function addMedicalLeave({
    commit
}, medicalLeave) {
    commit(ADD_MEDICAL_LEAVE, medicalLeave);
};

export function addSickLeave({
    commit
}, sickLeave) {
    commit(ADD_SICK_LEAVE, sickLeave);
};

export function addVacation({
    commit
}, vacation) {
    commit(ADD_VACATION, vacation);
};

export function addTimeOff({
    commit
}, timeOff) {
    commit(ADD_TIME_OFF, timeOff);
};

export function saveMedicalLeaves({
    commit
}, medicalLeaves) {
    return new Promise((resolve, reject) => {
        Vue.http.post(`${process.env.API}/api/vacations/medical-leave`, medicalLeaves).then((result) => {
            commit(SAVE_MEDICAL_LEAVES, result.body);
            resolve();
        })
        .catch(error => {
            reject(error);
        });
    });
}

export function saveVacations({
    commit
}, vacations) {
    return new Promise((resolve, reject) => {
        Vue.http.post(`${process.env.API}/api/vacations`, vacations).then((result) => {
            commit(SAVE_VACATIONS, result.body);
            resolve();
        })
        .catch(error => {
            reject(error);
        });
    });
}

export function saveSickLeaves({
    commit
}, sickLeaves) {
    return new Promise((resolve, reject) => {
        Vue.http.post(`${process.env.API}/api/vacations/sick-leaves`, sickLeaves).then((result) => {
            commit(SAVE_SICK_LEAVES, result.body);
            resolve();
        })
        .catch(error => {
            reject(error);
        });
    });
}

export function saveTimeOff({
    commit
}, timeOff) {
    return new Promise((resolve, reject) => {
        Vue.http.post(`${process.env.API}/api/vacations/time-off`, timeOff).then((result) => {
            commit(SAVE_TIME_OFF, result.body);
            resolve();
        })
        .catch(error => {
            reject(error);
        });
    });
}

export const fetchVacations = ({
    commit
}, userId) => {
    return new Promise((resolve, reject) => {
        Vue.http.get(`${process.env.API}/api/vacations/${userId}`).then(result => {
            commit(FETCH_VACATIONS, result.body);
            resolve();
        }).catch(error => {
            reject(error);
        });
    });
};

export function fetchHolidays({ commit }) {
    return new Promise((resolve, reject) => {
        Vue.http.get(`${process.env.API}/api/vacations/holidays`)
            .then(res => {
                commit(FETCH_HOLIDAYS, res.body);
                resolve();
            }).catch(error => {
                reject(error);
            });
    });
}

export function deleteHoliday({ commit }, id) {
    return new Promise((resolve, reject) => {
        Vue.http.delete(`${process.env.API}/api/vacations/holidays/delete/${id}`)
            .then(res => {
                commit(DELETE_HOLIDAY, res.body.id);
                resolve();
            }).catch(error => {
                reject(error);
            });
    });
}

export function changeHoliday({ commit }, payload) {
    return new Promise((resolve, reject) => {
        Vue.http.put(`${process.env.API}/api/vacations/holidays/edit/${payload.id}`, payload)
            .then(res => {
                commit(SAVE_HOLIDAY, res.body);
                resolve();
            }).catch(error => {
                reject(error);
            });
    });
}

export function createNewHoliday({ commit }, holidayDate) {
    return new Promise((resolve, reject) => {
        Vue.http.post(`${process.env.API}/api/vacations/holidays/create`, {
            date: holidayDate.format('MM/DD/YYYY')
        })
        .then(res => {
            commit(SAVE_HOLIDAY, res.body);
            resolve();
        }).catch(error => {
            reject(error);
        });
    });
}

export function addHoliday({ commit }, holiday) {
    commit(ADD_HOLIDAY, holiday);
}

export function editHoliday({ commit }, holidayId) {
    commit(EDIT_HOLIDAY, holidayId);
}

export function cancelHolidayEdit({ commit }) {
    commit(CANCEL_EDIT_HOLIDAY);
}

export const removeMedicalLeave = ({
    commit
}, medicalLeave) => {
    commit(REMOVE_MEDICAL_LEAVE, medicalLeave);
};

export const removeVacation = ({
    commit
}, vacation) => {
    commit(REMOVE_VACATION, vacation);
};

export const removeSickLeave = ({
    commit
}, sickLeave) => {
    commit(REMOVE_SICK_LEAVE, sickLeave);
};

export const removeTimeOff = ({
    commit
}, timeOff) => {
    commit(REMOVE_TIME_OFF, timeOff);
};

export const editSickLeave = ({
    commit
}, sickLeave) => {
    if (sickLeave.id) {
        return new Promise((resolve, reject) => {
            Vue.http.put(`${process.env.API}/api/vacations/sick-leaves/edit`, sickLeave).then(() => {
                resolve();
            }).catch(error => {
                reject(error);
            });
        });
    }
    commit(EDIT_SICK_LEAVE, sickLeave);
};

export const editVacation = ({
    commit
}, vacation) => {
    if (vacation.id) {
        return new Promise((resolve, reject) => {
            Vue.http.put(`${process.env.API}/api/vacations/edit`, vacation).then(() => {
                resolve();
            }).catch(error => {
                reject(error);
            });
        });
    }
    commit(EDIT_VACATION, vacation);
};

export const editTimeOff = ({
    commit
}, timeOff) => {
    if (timeOff.id) {
        return new Promise((resolve, reject) => {
            Vue.http.put(`${process.env.API}/api/vacations/time-off/edit`, timeOff).then(() => {
                resolve();
            }).catch(error => {
                reject(error);
            });
        });
    }
    commit(EDIT_TIME_OFF, timeOff);
};

export const editMedicalLeave = ({
    commit
}, medicalLeave) => {
    if (medicalLeave.id) {
        return new Promise((resolve, reject) => {
            Vue.http.put(`${process.env.API}/api/vacations/medical-leave/edit`, medicalLeave).then(() => {
                resolve();
            }).catch(error => {
                reject(error);
            });
        });
    }
    commit(EDIT_MEDICAL_LEAVE, medicalLeave);
};

export function deleteMedicalLeaves({
    commit
}, medicalLeaveIds) {
    return new Promise((resolve, reject) => {
        Vue.http.post(`${process.env.API}/api/vacations/medical-leave/delete`, medicalLeaveIds).then(() => {
            commit(DELETE_MEDICAL_LEAVES);
            resolve();
        }).catch(error => {
            reject(error);
        });
    });
};

export function deleteVacations({
    commit
}, vacationsId) {
    return new Promise((resolve, reject) => {
        Vue.http.post(`${process.env.API}/api/vacations/delete`, vacationsId).then(() => {
            commit(DELETE_VACATIONS);
            resolve();
        }).catch(error => {
            reject(error);
        });
    });
};

export function deleteSickLeaves({
    commit
}, sickLeavesId) {
    return new Promise((resolve, reject) => {
        Vue.http.post(`${process.env.API}/api/vacations/sick-leaves/delete`, sickLeavesId).then(() => {
            commit(DELETE_SICK_LEAVES);
            resolve();
        }).catch(error => {
            reject(error);
        });
    });
};

export function deleteTimeOff({
    commit
}, timeOffId) {
    return new Promise((resolve, reject) => {
        Vue.http.post(`${process.env.API}/api/vacations/time-off/delete`, timeOffId).then(() => {
            commit(DELETE_TIME_OFF);
            resolve();
        }).catch(error => {
            reject(error);
        });
    });
};

export const clearAllVacations = ({
    commit
}) => {
    commit(CLEAR_ALL_VACATIONS);
};



// WEBPACK FOOTER //
// ./src/store/modules/vacation/actions.js